module.exports = __webpack_public_path__ + "static/media/checkout.5b10cf58.svg";